<template>
  <section class="page contact">
    <div v-if="isMobile" class="contact__title">
      <AppTitle title="lof" size="medium"/>
    </div>
    <section class="contact__left" :class="{'not-loaded': notLoaded}">
      <template v-if="content">
        <h2 class="contact__baseline" v-html="content.acf.baseline"></h2>
        <p class="contact__text" v-html="content.acf.text"></p>
      </template>
    </section>
    <section class="contact__middle" :class="{'not-loaded': notLoaded}">
      <template v-if="content">
        <h2 class="contact__baseline text-hidden"> Social </h2>
        <div class="contact__mails">
          <template v-for="(item, index) in content.acf.contact_mails">
            <p :key="`p-${index}`" class="contact__mails__label"> {{ item.label }}:</p>
            <a :key="`a-${index}`"  :href="`mailto:${ item.email }`" class="contact__mails__link">{{ item.email }}</a>
          </template>
        </div>
      </template>
    </section>
    <section class="contact__right" :class="{'not-loaded': notLoaded}">
      <div class="contact__brand">
        <p class="contact__brand__word vertical-text">fashion</p>
        <p class="contact__brand__word vertical-text">of</p>
        <p class="contact__brand__word vertical-text">labor</p>
      </div>
    </section>
  </section>
</template>

<script>
  import Page from '@/mixins/Page'

  import AppTitle from '@/components/AppTitle'

  export default {
    name: 'Contact',

    mixins: [
        Page
    ],

    components: {
      AppTitle
    },

    data() {
      return {

      }
    },

    created()
    {
      const endpoint = '/wp-json/acf/v3/pages/42'
      this.loadDatas(endpoint, (res) => {

        this.content = res
        this.onLoadedDatas()

      })
    }
  }
</script>

<style lang="stylus">
  .contact
    width 100%
    margin-top 180px
    display flex
    flex-wrap nowrap
    border-top 1px solid #70706e
    border-bottom 1px solid #70706e

    @media(max-width 768px)
      width "calc(100vw -  %s * 2)" % $space-x-mobile
      margin 0 auto
      flex-direction column
      border none

  .contact__title
    @media(max-width 768px)
      // padding-top 20px

  .contact__left
    width calc(100% / 36 * 17)
    padding-left calc(100% / 36)
    padding-right calc(100% / 36 * 2)

    transform translate3d(0, 0px, 0)
    transition transform 1.2s $ease-in-out-circ 0s

    &.not-loaded
      transform translate3d(0, 50px, 0)
      transition transform 0s $ease-in-out-circ

      @media(max-width 768px)
        transform translate3d(0, 0px, 0)

    @media(max-width 768px)
      width 100%
      padding 0
      margin-bottom 50px

  .contact__middle
    position relative
    width calc(100% / 36 * 13)
    padding 0 calc(100% / 36 * 2)
    border-left 1px solid #70706e
    border-right 1px solid #70706e

    transform translate3d(0, 0px, 0)
    transition transform 1.2s $ease-in-out-circ 0s

    &.not-loaded
      transform translate3d(0, 50px, 0)
      transition transform 0s $ease-in-out-circ

      @media(max-width 768px)
        transform translate3d(0, 0px, 0)

    @media(max-width 768px)
      width 100%
      padding 50px 0
      border none

      &:before, &:after
        content ''
        position absolute
        left -1 * ($space-x-mobile)
        width 100vw
        height 1px
        background $black
      
      &:before
        top 0

      &:after
        bottom 0


      .contact__baseline
        @media(max-width 768px)
          display none

  .contact__right
    width calc(100% / 36 * 6)

    transform translate3d(0, 0px, 0)
    transition transform 1.2s $ease-in-out-circ 0s

    &.not-loaded
      transform translate3d(0, 50px, 0)
      transition transform 0s $ease-in-out-circ

      @media(max-width 768px)
        transform translate3d(0, 0px, 0)

    @media(max-width 768px)
      display none

  .contact__baseline
    margin-top 80px
    margin-bottom 65px
    color $grey-light
    text-transform uppercase
    line-height 1
    interpolate('font-size', 1600px, 2560px, 110px, 140px);

    @media(max-width 1600px)
      interpolate('font-size', 768px, 1600px, 56px, 110px);

    @media(max-width 768px)
      margin-top 60px
      margin-bottom 20px
      font-size 32px

  .contact__text
    line-height 1
    text-transform uppercase
    interpolate('font-size', 1600px, 2560px, 60px, 84px);

    @media(max-width 1600px)
      interpolate('font-size', 768px, 1600px, 30px, 60px);

    @media(max-width 768px)
      font-size 32px

  .contact__mails
    font-size 18px
    line-height 1
    text-transform uppercase
    interpolate('font-size', 1600px, 2560px, 25px, 35px);

    @media(max-width 1600px)
        interpolate('font-size', 768px, 1600px, 15px, 25px);

    @media(max-width 768px)
      font-size 16px

  .contact__mails__link
    display block
    margin-bottom 25px

    &:last-child
      margin-bottom 0

  .contact__brand
    margin-top 80px
    margin-bottom 80px
    display flex
    flex-direction column
    align-items center

  .contact__brand__word
    margin-bottom 50px
    font-family 'Sabon'
    letter-spacing 0.1em
    text-transform uppercase
    text-align center
    line-height 1
    interpolate('font-size', 1600px, 2560px, 120px, 172px);

    @media(max-width 1600px)
        interpolate('font-size', 768px, 1600px, 58px, 120px);

    &:last-child
      margin-bottom 0
</style>